import { render, staticRenderFns } from "./TabelaGestaoCertificacao.vue?vue&type=template&id=7d4ad5c9&scoped=true"
import script from "./TabelaGestaoCertificacao.vue?vue&type=script&lang=js"
export * from "./TabelaGestaoCertificacao.vue?vue&type=script&lang=js"
import style0 from "./TabelaGestaoCertificacao.vue?vue&type=style&index=0&id=7d4ad5c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ad5c9",
  null
  
)

export default component.exports